import { memo } from "react";
import { NO_MOBILE_NUMBER } from "../../../Constants/stringConstants";
import { createWhatsAppLink, shouldWhatsappShow } from "../../../Services/common";
import IconResource from "../../../Wrapper/IconResource/IconResource";
import Button from "../Button/Button";
import Text from "../Text/Text";
import CustomTooltip from "../Tooltip/CustomTooltip";

const NavBar = memo(
  ({
    heading,
    onClick,
    button,
    buttonIcon,
    buttonIconsuff,
    setModalShow,
    Icon,
    button2,
    buttonIcon2,
    buttonIconsuff2,
    button2onclick,
    button2loading,
    button3,
    buttonIcon3,
    buttonIconsuff3,
    button3onclick,
    button3loading,
    button4,
    buttonIcon4,
    buttonIconsuff4,
    button4onclick,
    button5,
    buttonIcon5,
    buttonIconsuff5,
    button5onclick,
    button6,
    buttonIcon6,
    buttonIconsuff6,
    button6onclick,
    contactLink,
    mobileMno,
    buttons_responsive,
    buttonType,
    buttonType2,
    buttonType3,
    buttonType4,
    buttonType5,
    buttonType6,
    buttononclick,
    buttondisabled,
    button2disabled,
    button3disabled,
    button4disabled,
    button5disabled,
    button6disabled,
    children,
  }) => {
    const rightButtonHandler = () => {
      if (setModalShow) {
        setModalShow(true);
      }
    };
    return (
      <>
        <div className="nav_bar d-flex flex-wrap align-items-center">
          <div className="start d-flex align-items-start gap-2 flex-grow-1 navbar_heading">
            <Button
              buttonType="icon"
              icon={<IconResource type={Icon} size={20} />}
              color="black"
              onClick={onClick}
            />
            <Text type="h2" className="align-self-center" text={heading} />
          </div>
          <div
            className={`d-flex align-items-center gap-2 ms-auto mt-2 ${buttons_responsive && "navbar_buttons_wrap"}`}
          >
            {button ? (
              <Button
                buttonType={buttonType || "primary"}
                prefixIcon={buttonIcon ? <IconResource type={buttonIcon} size={18} /> : ""}
                suffixIcon={buttonIconsuff ? <IconResource type={buttonIconsuff} size={18} /> : ""}
                text={button}
                disabled={buttondisabled}
                onClick={buttononclick || rightButtonHandler}
              />
            ) : null}
            {button2 ? (
              <Button
                buttonType={buttonType2 || "primary"}
                prefixIcon={buttonIcon2 ? <IconResource type={buttonIcon2} size={18} /> : ""}
                suffixIcon={
                  buttonIconsuff2 ? <IconResource type={buttonIconsuff2} size={18} /> : ""
                }
                text={button2}
                isLoading={button2loading}
                disabled={button2disabled || button2loading}
                onClick={button2onclick}
              />
            ) : null}
            {contactLink ? (
              <CustomTooltip
                text={!shouldWhatsappShow(mobileMno?.mno) && NO_MOBILE_NUMBER}
                type="tooltip"
                placement="top"
              >
                <Button
                  buttonType="primary"
                  disabled={!shouldWhatsappShow(mobileMno?.mno)}
                  prefixIcon={
                    buttonIcon3 ? (
                      <IconResource
                        size={20}
                        type={shouldWhatsappShow(mobileMno?.mno) ? "whatsapp" : "whatsapp"}
                      />
                    ) : (
                      ""
                    )
                  }
                  suffixIcon={
                    buttonIconsuff3 ? (
                      <IconResource
                        type={shouldWhatsappShow(mobileMno?.mno) ? "whatsapp" : "whatsapp"}
                        size={20}
                      />
                    ) : (
                      ""
                    )
                  }
                  text={"Click on Whatsapp"}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();

                    if (shouldWhatsappShow(mobileMno?.mno)) {
                      window.open(createWhatsAppLink(mobileMno?.mno, mobileMno?.name));
                    }
                  }}
                />
              </CustomTooltip>
            ) : null}
            {button3 ? (
              <Button
                buttonType={buttonType3 || "primary"}
                prefixIcon={buttonIcon3 ? <IconResource type={buttonIcon3} size={18} /> : ""}
                suffixIcon={
                  buttonIconsuff3 ? <IconResource type={buttonIconsuff3} size={18} /> : ""
                }
                text={button3}
                isLoading={button3loading}
                disabled={button3disabled || button3loading}
                onClick={button3onclick}
              />
            ) : null}
            {button4 ? (
              <Button
                buttonType={buttonType4 || "primary"}
                prefixIcon={buttonIcon4 ? <IconResource type={buttonIcon4} size={18} /> : ""}
                suffixIcon={
                  buttonIconsuff4 ? <IconResource type={buttonIconsuff4} size={18} /> : ""
                }
                text={button4}
                disabled={button4disabled}
                onClick={button4onclick}
              />
            ) : null}
            {button5 ? (
              <Button
                buttonType={buttonType5 || "primary"}
                prefixIcon={buttonIcon5 ? <IconResource type={buttonIcon5} size={18} /> : ""}
                suffixIcon={
                  buttonIconsuff5 ? <IconResource type={buttonIconsuff5} size={18} /> : ""
                }
                text={button5}
                disabled={button5disabled}
                onClick={button5onclick}
              />
            ) : null}

            {button6 ? (
              <Button
                buttonType={buttonType6 || "primary"}
                prefixIcon={buttonIcon6 ? <IconResource type={buttonIcon6} size={18} /> : ""}
                suffixIcon={
                  buttonIconsuff6 ? <IconResource type={buttonIconsuff6} size={18} /> : ""
                }
                text={button6}
                disabled={button6disabled}
                onClick={button6onclick}
              />
            ) : null}
            {children}
          </div>
        </div>
      </>
    );
  },
);

export default NavBar;
